import { XButton, useAsync } from '@orderx/lab/ui';
import React from 'react';
import { Balance } from '../../../../XV2';
import { apiMePayPost } from '../../../../api/me.pay.[post]';

type ProviderPayBalanceInput = {
    config: {
        balance: Pick<Balance, 'id' | 'name' | 'namePublic' | 'type'>;
        paymentId?: number;
        orderId?: number;
    };
    onSuccess(response: any): void;
};

export function ProviderPayBalance(input: ProviderPayBalanceInput) {
    const { config, onSuccess } = input;

    const pay = useAsync(async () => {
        onSuccess(
            await apiMePayPost({
                body: {
                    balanceId: config.balance.id,
                    paymentId: config.paymentId,
                    orderId: config.orderId,
                },
            }),
        );
    });

    return (
        <>
            <XButton {...pay.buttonProps} color={'primary'}>
                Pay with: {config.balance.namePublic || config.balance.name || '?'}
            </XButton>
        </>
    );
}
